const videoEls = document.querySelectorAll<HTMLElement>(
	'[data-video-fullscreen]',
);

videoEls.forEach((el) => {
	const video = el.querySelector('video');
	if (!video) return;

	video.muted = true;

	/**
	 * Unmute button
	 */

	const muteButton = el.querySelector<HTMLButtonElement>('[data-mute]');

	if (muteButton !== null) {
		const muteLabel = muteButton.getAttribute('data-mute-label') || '';
		const unmuteLabel = muteButton.textContent || '';

		muteButton.addEventListener('click', () => {
			if (video.muted) {
				video.muted = false;
			} else {
				video.muted = true;
			}
		});

		video.addEventListener('volumechange', () => {
			if (video.muted) {
				muteButton.textContent = unmuteLabel;
				muteButton.classList.remove('fullscreen-video__button--mute');
				muteButton.classList.add('fullscreen-video__button--unmute');
			} else {
				muteButton.textContent = muteLabel;
				muteButton.classList.remove('fullscreen-video__button--unmute');
				muteButton.classList.add('fullscreen-video__button--mute');
			}
		});
	}

	/**
	 * Play/pause button
	 */

	const playButton = el.querySelector<HTMLButtonElement>('[data-play]');

	if (playButton !== null) {
		const pauseLabel = playButton.getAttribute('data-pause-label') || '';
		const playLabel = playButton.textContent || '';

		playButton.addEventListener('click', () => {
			if (video.paused) {
				play();
			} else {
				pause();
			}
		});

		video.addEventListener('play', () => {
			playButton.textContent = pauseLabel;
		});

		video.addEventListener('pause', () => {
			playButton.textContent = playLabel;
		});
	}

	/**
	 * Show/hide buttons
	 */

	let timer: number;
	const hideAfterDelay = (mouseOverEl?: HTMLElement) => {
		if (timer) {
			window.clearTimeout(timer);
		}

		el.classList.remove('fullscreen-video--hide-actions');
		timer = window.setTimeout(() => {
			if (!mouseOverEl || mouseOverEl === video) {
				el.classList.add('fullscreen-video--hide-actions');
			}
		}, 700);
	};

	el.addEventListener('mousemove', (ev) => {
		hideAfterDelay(ev.target instanceof HTMLElement ? ev.target : undefined);
	});

	const play = () => {
		video.play();
	};

	const pause = () => {
		video.pause();
	};

	const observer = new IntersectionObserver(
		(entries) => {
			if (entries.some((entry) => entry.isIntersecting)) {
				play();
			} else {
				pause();
			}
		},
		{
			threshold: 0,
			rootMargin: '-10px',
		},
	);
	observer.observe(el);
});
